// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-summary{display:flex;flex-wrap:wrap}.filter-summary__address,.filter-summary__distance,.filter-summary__results-text{flex:1 1 auto}.filter-summary__services{font-family:var(--font-heavy);font-size:14px;font-weight:700;color:var(--color-eggplant)}", ""]);
// Exports
module.exports = exports;
